import { Button, Modal } from "antd";
import React from "react";

type Props = {
  onOk: () => void;
  onCancel: () => void;
  visible: boolean;
};
const ConfirmModal: React.FC<Props> = ({ onOk, onCancel, visible }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      closable={false}
      maskClosable={false}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
          height: "250px",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: "2.5rem",
            textAlign: "center",
            width: "80%",
          }}
        >
          ยืนยันการบันทึกข้อมูล
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2,1fr)",
              gap: "1rem",
              marginTop: "4rem",
            }}
          >
            <Button
              style={{
                backgroundColor: "#6598F6",
                color: "#F0F0F0",
                borderRadius: "8px",
                height: "60px",
                fontSize: "2rem",
                fontWeight: "bold",
              }}
              onClick={() => {
                onOk();
              }}
            >
              ยืนยัน
            </Button>
            <Button
              style={{
                backgroundColor: "#C95559",
                color: "#F0F0F0",
                borderRadius: "8px",
                height: "60px",
                fontSize: "2rem",
                fontWeight: "bold",
              }}
              onClick={onCancel}
            >
              ไม่ยืนยัน
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
